import * as React from 'react';
import { illustrationRoot } from 'ui/illustrations/illustrationCssDefs';

export type IllustrationColorProps = Pick<IllustrationProps, 'color'>;
export type IllustrationColor = 'primary' | 'dark' | 'disabled';

interface IllustrationProps {
  color: IllustrationColor;
  dots?: React.ReactNode;
  fills?: React.ReactNode;
  shadows?: React.ReactNode;
  strokes?: React.ReactNode;
}

export const Illustration: React.FunctionComponent<IllustrationProps> = ({
  color,
  dots,
  fills,
  shadows,
  strokes,
}) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      css={illustrationRoot(color)}
    >
      {shadows && <g className="shadows">{shadows}</g>}
      {strokes && <g className="strokes">{strokes}</g>}
      {fills && <g className="fills">{fills}</g>}
      {dots && <g className="dots">{dots}</g>}
    </svg>
  );
};

export default Illustration;
